import { render, staticRenderFns } from "./senior-en.vue?vue&type=template&id=b8b13e2c&lang=pug&"
import script from "./senior-en.vue?vue&type=script&lang=js&"
export * from "./senior-en.vue?vue&type=script&lang=js&"
import style0 from "./senior-en.vue?vue&type=style&index=0&id=b8b13e2c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports